import Rows, {Options, Total} from './Rows';

const Body = props => (
    <tbody>
        <Rows {...props} />
        <Options {...props} />
        <tr className="divider">
            <td colSpan="2" />
        </tr>
        <Total {...props} />
    </tbody>
);

export default Body;
